import { graphql, useStaticQuery } from 'gatsby';
import { ProductPromoData } from 'utils/types';

type PageProductPromo = {
  product: ProductPromoData;
};

type PromoDataResult = {
  nodes: PageProductPromo[];
};

const getAllPdpPromoData = (allContentfulPdpPage: PromoDataResult) =>
  allContentfulPdpPage?.nodes
    .filter((page) => {
      if (!page) return false;
      return true;
    })
    .map((page: PageProductPromo) => ({
      slug: page.product.slug,
      onSale: page.product.onSale,
      promoText: page.product.promoText,
    }));

const usePromoData = (): ProductPromoData[] => {
  const { allContentfulPdpPage } = useStaticQuery(graphql`
    query {
      allContentfulPdpPage {
        nodes {
          product {
            onSale
            slug
            promoText
          }
        }
      }
    }
  `);

  const allProductPromoData = getAllPdpPromoData(allContentfulPdpPage);

  return allProductPromoData;
};
export default usePromoData;
